const homeChevrons = document.querySelector('#jump-chevrons')

if (homeChevrons) {
  window.addEventListener('scroll', function(e) {
    var scrolled = window.pageYOffset
    if (scrolled > 400) {
      if (!homeChevrons.classList.contains('up')) {
        homeChevrons.classList.add('up')
        homeChevrons.href = '#top'
      }
    } else {
      if (homeChevrons.classList.contains('up')) {
        homeChevrons.classList.remove('up')
        homeChevrons.href = '#bottom'
      }
    }
  })
}
